import { PaymentProcessorAccountConfigurationBase } from '../payment-processor-account-configuration-base';

export class MunicipayPaymentProcessorAccountConfiguration extends PaymentProcessorAccountConfigurationBase {
  siteId: string;
  prodId: string;
  urlKey: string;

  constructor(
    options?: Partial<MunicipayPaymentProcessorAccountConfiguration>
  ) {
    super(options);
  }
}
